import { Grid } from "@trussworks/react-uswds";
import HealthFirstColorado  from "../../images/hcpf-logo-2x.png";
import { useTranslation } from "react-i18next";
import ZipCountyRAE from "../../data/Zip_County_RAE.json";
import styled from "styled-components";
import { CSSProperties, ReactNode, useState } from "react";
import Modal from "../Modal";

type ZipToCounty = {
    Zip: number,
    County: string,
    Entity: string,
    Phone: string
  };
const ZipToCountyList = ZipCountyRAE as ZipToCounty[];

const TitleStyle = styled.div`
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`;

const LinkButton: CSSProperties = {
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer",
  textDecoration: "underline",
  display: "inline",
  margin: "0",
  padding: "0"
};

function uniqueRAE(value: ZipToCounty, index: number, self: ZipToCounty[]) {
  return self.map(x => x.Entity).indexOf(value.Entity) === index;
}

const healthPlans = "Rocky Mountain Health Plans";//TODO: eventually this needs to not be hard coded! Also other available times may be needed eventually or other providers may need to be checked for this.
const GetRaeEntitySection = (zipInfo: ZipToCounty): ReactNode => {
  const { t } = useTranslation();
  return <>
    <p>{zipInfo.County + " " + t("county")}</p>
    <ul>
      <li>
        {zipInfo.Entity}: <a href={"tel:" + zipInfo.Phone} >{zipInfo.Phone}</a><br/>
        <p>{zipInfo.Entity === healthPlans ? t("rae24hours") : t("raeHours")}</p>
      </li>
    </ul>
  </>
}

let visible = true;
const GetRAEInfoByZipCode = (zipCode: string): [content: ReactNode, isModal: boolean, is24Hour: boolean] => {
    const { t } = useTranslation();
    let zipInfo = ZipToCountyList.filter((x) => x.Zip.toString() === zipCode).filter(uniqueRAE);
    visible = true;
    if (zipInfo.length === 0) {
        visible = false;
        return ["error", false, false];
    }

    if (zipInfo.length === 1) {//single county (just phone)
        let is24Hour = zipInfo[0].Entity === healthPlans;
        return [(<>{zipInfo[0].Entity}: <a href={"tel:" + zipInfo[0].Phone} >{zipInfo[0].Phone}</a></>), false, is24Hour];
    } else {//multiple counties (modal layout)
        let modalContent: ReactNode = <div>
        <TitleStyle>{t("raeDialogTitle")}</TitleStyle>
        {zipInfo.map((info) => {
            return GetRaeEntitySection(info);
        })}
        </div>;
        return [modalContent, true, false];
    }
};
  
const GetText = (isMobile: boolean, zipCode: string) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  let [content, isModal, is24Hours] = GetRAEInfoByZipCode(zipCode);
  let raeTextParts = t("raeText").split("####");
  // eslint-disable-next-line no-throw-literal
  if (raeTextParts.length < 2) throw "Error in translating 'raeText'.";
  let raeMultiParts = t("raeMultipleProvidersText").split("$$$$");
  // eslint-disable-next-line no-throw-literal
  if (raeMultiParts.length < 2) throw "Error in translating 'raeMultipleProvidersText'.";
  return (
    <div className={isMobile ? "align-me-mobile-text" : "align-me-text"}>
      <div className="inner-text-style">
      {isModal ? 
          <>
            <Modal isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} buttonText={t("close")} >{content}</Modal>
            <div>{raeMultiParts[0]} <button style={LinkButton} onClick={() => setIsOpen(true)}>{t("raeHealthFirstHyperLink")}</button> {raeMultiParts[1]}</div>
          </>
          : <p>{raeTextParts[0]} {content} {raeTextParts[1] + (is24Hours ? t("rae24hours") : t("raeHours"))}</p>
        }
      </div>
    </div>
  );
};
const GetLogo = (isMobile: boolean) => {
  return (isMobile ?
    <div className="div-hcpf-mobile-logo">
      <img
        id="imgHcpfMobileLogo"
        alt="Health First Colorado"
        src={HealthFirstColorado}
      />
    </div>
    :
    <div className="align-me-logo">
      <img src={HealthFirstColorado} alt="Health First Colorado" className="centerImg" />
    </div>
  );
};
type RAECardProps = {
  isMobile: boolean;
  zipCode: string;
};
export default function RAECard({ isMobile, zipCode }: RAECardProps) {
  return (visible ? <>
    <div className="border-bottom border-bottom-lighter">
      <div
        className="hcpf-card hcpf-card-div"
        id={"raecard"}
        key="999999998">
        {isMobile ? 
          GetLogo(isMobile)
        : <></>}
        <Grid
          row
          mobile={{ col: true }}
          className="flex-justify-center tablet:flex-justify flex-align-center hcpf-card-div">
          <div className="div-parent">
            {!isMobile ? 
              GetLogo(isMobile)
            : <></>}
            {GetText(isMobile, zipCode)}
          </div>
        </Grid>
      </div>
    </div>
  </>: <></>);
}